import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckIcon, CrownIcon, XIcon } from 'lucide-react';
import { vipAlerts } from '../data/dashboardData';
export function VipAlerts() {
  const [alerts, setAlerts] = useState(vipAlerts);
  return <section aria-labelledby="vip-title" className="border border-[#9c7a44] bg-[#10283b] text-white" data-id="element-150">
      <div className="flex items-center justify-between border-b border-white/10 p-4 sm:p-5" data-id="element-151">
        <div className="flex items-center gap-3" data-id="element-152">
          <span className="grid h-8 w-8 place-items-center border border-[#d6bd87]/50 text-[#d6bd87]" data-id="element-153">
            <CrownIcon size={15} data-id="element-154" />
          </span>
          <div data-id="element-155">
            <h2 id="vip-title" className="font-serif text-xl" data-id="element-156">
              VIP arrivals
            </h2>
            <p className="mt-0.5 text-[10px] text-[#aeb8bd]" data-id="element-157">
              High-touch attention required
            </p>
          </div>
        </div>
        <span className="bg-[#d6bd87] px-2 py-1 text-[10px] font-bold text-[#10283b]" data-id="element-158">
          {alerts.length} OPEN
        </span>
      </div>
      <div className="divide-y divide-white/10" data-id="element-159">
        <AnimatePresence initial={false} data-id="element-160">
          {alerts.map(alert => <motion.article key={alert.name} exit={{
          opacity: 0,
          height: 0
        }} transition={{
          duration: 0.25
        }} className="overflow-hidden p-4" data-id="element-161">
              <div className="flex gap-3" data-id="element-162">
                <span className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-[#d6bd87] text-xs font-bold text-[#10283b]" data-id="element-163">
                  {alert.initials}
                </span>
                <div className="min-w-0 flex-1" data-id="element-164">
                  <div className="flex items-start justify-between gap-2" data-id="element-165">
                    <div data-id="element-166">
                      <h3 className="text-sm font-semibold" data-id="element-167">{alert.name}</h3>
                      <p className="mt-0.5 text-[9px] font-bold uppercase tracking-[0.14em] text-[#d6bd87]" data-id="element-168">
                        {alert.tier}
                      </p>
                    </div>
                    <button onClick={() => setAlerts(items => items.filter(item => item.name !== alert.name))} type="button" aria-label={`Dismiss ${alert.name} alert`} className="text-[#8798a3] hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#d6bd87]" data-id="element-169">
                      <XIcon size={15} data-id="element-170" />
                    </button>
                  </div>
                  <p className="mt-3 text-xs text-[#e1e4e5]" data-id="element-171">{alert.stay}</p>
                  <p className="mt-1 text-[10px] text-[#9eabb3]" data-id="element-172">
                    {alert.detail}
                  </p>
                  <div className="mt-3 flex items-center justify-between gap-2 border-t border-white/10 pt-3" data-id="element-173">
                    <p className="text-[10px] font-semibold text-[#e3c994]" data-id="element-174">
                      {alert.accent}
                    </p>
                    <button type="button" onClick={() => setAlerts(items => items.filter(item => item.name !== alert.name))} className="flex shrink-0 items-center gap-1 border border-white/20 px-2 py-1 text-[9px] font-bold uppercase tracking-wider hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#d6bd87]" data-id="element-175">
                      <CheckIcon size={11} data-id="element-176" /> Resolve
                    </button>
                  </div>
                </div>
              </div>
            </motion.article>)}
        </AnimatePresence>
        {alerts.length === 0 ? <p className="p-6 text-center text-xs text-[#aeb8bd]" data-id="element-177">
            All VIP arrangements are confirmed.
          </p> : null}
      </div>
    </section>;
}